import React from "react";

export function CalendarTimeLabels() {
  return (
    <div className="chronos-calendar-time-item">
      <div className="chronos-calendar-unit-info chronos-calendar-unit-label">
        Duration
      </div>
      <div className="chronos-calendar-unit-label"></div>
      <div className="chronos-calendar-unit-label">Unit of time</div>
      <div className="chronos-calendar-unit-label">Plural of Unit</div>
    </div>
  );
}
